import { render } from "./VerbsTableGame.vue?vue&type=template&id=81b08462&scoped=true"
import script from "./VerbsTableGame.vue?vue&type=script&lang=js"
export * from "./VerbsTableGame.vue?vue&type=script&lang=js"

import "./VerbsTableGame.vue?vue&type=style&index=0&id=81b08462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b08462"]])

export default __exports__